import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsAYAnniversaryCampaignActive = () => {
  const isAYAnniversaryCampaignActive = [
    useIsFeatureActive('ay_anniversary_campaign_PT'),
    useIsFeatureActive(
      'ay_anniversary_campaign_DE_AT_CH_NL_BE_PL_CZ_SK_HU_SI_HR_FR_DK_SE_IT_ES_NO_LU',
    ),
    useIsFeatureActive('ay_anniversary_campaign_RO_LT_LV_EE_BG_FI_GR_CY'),
  ]
    .map(value => value.isActive)
    .some(Boolean);

  return isAYAnniversaryCampaignActive;
};
